/**
 * Mensagem de erro dos fluxos de autorização da Meta (Facebook/Instagram).
 *
 * O toast genérico "tente novamente" escondia a causa em três situações
 * diferentes, e em nenhuma delas tentar de novo resolve:
 *  - o backend sabe o motivo e o manda em `{ error }` (config ausente,
 *    seleção expirada, Page fora da autorização) → mostra o motivo;
 *  - algo NA FRENTE do Rails respondeu (proxy/WAF devolvendo HTML, como o
 *    GoCache no homolog em 2026-09-17) → não há JSON, só o status → mostra
 *    o status e diz que a resposta veio sem detalhe;
 *  - a requisição nem saiu (rede) → genérico.
 *
 * `keyPrefix` é o bloco i18n do canal (`INBOX_MGMT.ADD.FB` ou
 * `INBOX_MGMT.ADD.INSTAGRAM`), que precisa ter ERROR_AUTH,
 * ERROR_AUTH_DETAIL e ERROR_AUTH_OPAQUE.
 */
export function metaAuthErrorMessage(error, t, keyPrefix) {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const detail = [data?.error, data?.message].find(
    value => typeof value === 'string' && value.trim()
  );

  if (detail) return t(`${keyPrefix}.ERROR_AUTH_DETAIL`, { detail });
  if (status) return t(`${keyPrefix}.ERROR_AUTH_OPAQUE`, { status });
  return t(`${keyPrefix}.ERROR_AUTH`);
}
